<script setup lang="ts">
import { CourtType, NftSkill, Scarcity, Skill } from "fungi-types";
import { useI18n } from "vue-i18n";
import L5Chart from "~/components/marketplace/L5Chart.vue";
import L10Chip from "~/components/marketplace/L10Chip.vue";
import BonusChip from "../marketplace/BonusChip.vue";
import GwEntries from "../marketplace/GwEntriesChip.vue";
import MetaChip from "../marketplace/MetaChip.vue";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    l10: number;
    skill: Skill;
    scarcity: Scarcity;
    court: CourtType;
    l5: NftSkill["l5"];
    season: string;
    xp?: number;
    entries?: NftSkill["entries"];
  }>(),
  {
    l10: undefined,
    l5: undefined,
  }
);
</script>

<template>
  <div class="w-full flex items-stretch justify-between gap-1 text-black">
    <div class="flex flex-row gap-1">
      <L10Chip :score="l10" />
      <BonusChip :xp="xp" :season="season" :scarcity="scarcity" />
    </div>

    <div class="flex flex-row items-center gap-1">
      <GwEntries :entries="entries" />
      <L5Chart :l5="l5" />
    </div>
  </div>
  <div class="flex flex-row gap-1 text-xs flex-wrap">
    <MetaChip type="secondary" :text="t(`skills.${skill}`)" :tooltip="t('skill')" />
    <MetaChip type="secondary" :text="t(`scarcities.${scarcity}`)" :tooltip="t('scarcity')" />
    <MetaChip type="secondary" :text="t(`court.${court}`)" :tooltip="t('skill')" />
  </div>
</template>

<style scoped lang="scss">
.return-bg {
  @apply bg-skill-return;
}
.service-bg {
  @apply bg-skill-service;
}
.power-bg {
  @apply bg-skill-power;
}
.mental-bg {
  @apply bg-skill-mental;
}
</style>
